import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { FirstlifeLayoutComponent } from './firstlife/layout/firstlife-layout/firstlife-layout.component';
import { FundrichLayoutComponent } from './firstlife/layout/fundrich-layout/fundrich-layout.component';


const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./firstlife/pages/login/login.module').then(mod => mod.LoginModule),
    data: {
      title: '會員登入｜第一金人壽網路投保',
      description: '歡迎登入第一金人壽網路投保'
    }
  },
  {
    path: 'external',
    loadChildren: () => import('./firstlife/pages/external/external.module').then(mod => mod.ExternalModule)
  },
  {
    path: 'fundrich',
    component: FundrichLayoutComponent,
    loadChildren: () => import('./firstlife/firstlife.module').then(mod => mod.FirstlifeModule),
    data: { isfundrich: true },
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: '',
    component: FirstlifeLayoutComponent,
    loadChildren: () => import('./firstlife/firstlife.module').then(mod => mod.FirstlifeModule),
    data: { isfundrich: false },
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload', paramsInheritanceStrategy: 'always'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
